module.exports = __webpack_public_path__ + "static/sexologaRecurso-4c3ae22542d5107498475a42e3c892c8.svg";